module.exports = __webpack_public_path__ + "static/media/edit_audio_detail.96ee0787.svg";